webpackJsonp([96758821237171],{

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n  padding: 2rem 0 2rem 3rem;\n  position: relative;\n\n  &::after {\n    content: \'\';\n    text-align: center;\n    font-size: 4.2rem;\n    font-family: \'Catamaran\', sans-serif;\n    font-style: normal;\n    font-weight: 100;\n    position: absolute;\n    left: 3rem;\n    top: 50%;\n    margin-top: -17px;\n    height: 32px;\n    width: 32px;\n    border-radius: 50%;\n    background: ', ';\n  }\n\n  > a {\n    padding: 2rem 2rem 2rem 4.5rem;\n  }\n'], ['\n\n  padding: 2rem 0 2rem 3rem;\n  position: relative;\n\n  &::after {\n    content: \'\';\n    text-align: center;\n    font-size: 4.2rem;\n    font-family: \'Catamaran\', sans-serif;\n    font-style: normal;\n    font-weight: 100;\n    position: absolute;\n    left: 3rem;\n    top: 50%;\n    margin-top: -17px;\n    height: 32px;\n    width: 32px;\n    border-radius: 50%;\n    background: ', ';\n  }\n\n  > a {\n    padding: 2rem 2rem 2rem 4.5rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 2rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n'], ['\n  padding: 2rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid black;\n\n  > a {\n    color: black;\n  }\n'], ['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid black;\n\n  > a {\n    color: black;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(18);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Utils
	
	
	// Styles
	
	
	var LinkWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return (0, _styleUtils.backgroundTheme)(props.themeColors);
	});
	
	var HeaderSection = _styledComponents2.default.section(_templateObject2);
	
	var BackLinkWrap = _styledComponents2.default.div(_templateObject3);
	
	var AllFoodsPage = function AllFoodsPage(_ref) {
	  var data = _ref.data;
	
	
	  // show only live foods, ordered aplhabetically
	  var liveFoods = _lodash2.default.filter(_lodash2.default.sortBy(data.allGoogleSheetFoodsRow.edges, function (_ref2) {
	    var node = _ref2.node;
	    return node.title;
	  }), function (_ref3) {
	    var node = _ref3.node;
	    return node.live;
	  });
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'All Foods'
	      )
	    ),
	    _react2.default.createElement(
	      HeaderSection,
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'All Foods'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Here are all of the foods currently on the site.'
	      ),
	      _react2.default.createElement(
	        BackLinkWrap,
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          '\u2190 Back'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      liveFoods.map(function (_ref4) {
	        var node = _ref4.node;
	        return _react2.default.createElement(
	          LinkWrapper,
	          {
	            key: node.id,
	            themeColors: node.themecolor.split('-'),
	            textColor: node.textcolor || 'white' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' + (0, _utils.createSlugFromTitle)(node.title) + '/' },
	            node.title
	          )
	        );
	      })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = AllFoodsPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-foods-js-ebf272e88436f011d704.js